import { memo, useState, useRef, useEffect } from 'react';

import { FiMapPin, FiX, FiChevronDown, FiChevronUp } from 'react-icons/fi';

import { PinnedMessageData } from '@common/types/api';

import * as S from './styles';

type PinnedMessageProps = {
  message: PinnedMessageData;
  isModerator: boolean;
  onUnpin: () => void;
};

const PinnedMessage = ({
  message,
  isModerator,
  onUnpin,
}: PinnedMessageProps) => {
  const [expanded, setExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsClamped(el.scrollHeight > el.clientHeight);
    }
  }, [message.content]);

  return (
    <S.Container onClick={() => isClamped && setExpanded((prev) => !prev)}>
      <S.Content>
        <S.TopRow>
          <S.Author>{message.author_name}</S.Author>
          <S.Tag>
            <FiMapPin size={9} /> Fixada
          </S.Tag>
        </S.TopRow>
        <S.Text ref={textRef} $expanded={expanded}>
          {message.content}
        </S.Text>
      </S.Content>
      {/* eslint-disable-next-line no-nested-ternary */}
      {isModerator ? (
        <S.UnpinButton
          type="button"
          title="Desafixar mensagem"
          onClick={(e) => {
            e.stopPropagation();
            onUnpin();
          }}
        >
          <FiX />
        </S.UnpinButton>
      ) : isClamped ? (
        <S.UnpinButton as="span">
          {expanded ? <FiChevronUp /> : <FiChevronDown />}
        </S.UnpinButton>
      ) : null}
    </S.Container>
  );
};

export default memo(PinnedMessage);
